import React, { Component } from 'react';
import { Grid, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Edit extends Component {

  state = {
    name: this.props.name,
    address: this.props.address,
    taluk: this.props.taluk,
    district: this.props.district,
    state: this.props.state,
    id: this.props.id,
    phone: this.props.phone,
    data: this.props.data,
    pincode: this.props.pincode,
    gstin: this.props.gstin,
    load: false,
    message: ''
  };


  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  cancel() {
    this.props.handleClose();
  }

  update() {
    let context = this;
    context.setState({
      load: true,
      message: 'Updating Branch Details'
    });
    let name = this.state.name;
    let address = this.state.address;
    let taluk = this.state.taluk;
    let district = this.state.district;
    let state = this.state.state;
    let id = this.state.id;
    let oldData = this.state.data;
    let phone = this.state.phone;
    let pincode = this.state.pincode;
    let gstin = this.state.gstin;

    let data1 = { 'name': name, 'address': address, 'taluk': taluk, 'district': district,
                 'state': state, 'id': id, 'phone': phone, 'pincode': pincode, 'gstin': gstin };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'branchdetails/update.php',
      success: function(data)
      {
        context.setState({ load: false });
        if (data == 1) {
          for (var i = 0; i < oldData.length; i++) {
            if (id == oldData[i].id) {
              oldData[i].name = name;
              oldData[i].address = address;
              oldData[i].taluk = taluk;
              oldData[i].district = district;
              oldData[i].state = state;
              oldData[i].phone = phone;
              oldData[i].pincode = pincode;
              oldData[i].gstin = gstin;
            }
          }
          context.props.updateData(oldData);
        }
        else {
          alert('Error!!!')
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    let { load, message } = this.state;
    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            Branch<br/>
            <Input focus value={this.state.name}
                onChange={this.onChange('name')}
                placeholder='Branch' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            Address<br/>
            <Form>
              <TextArea id='address' value={this.state.address}
                  autoHeight placeholder='Address' fluid
                  onChange={this.onChange('address')}
                  style={{ minHeight: 100, borderColor: '#5A9CBB' }} />
            </Form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Taluk<br/>
            <Input focus value={this.state.taluk}
                onChange={this.onChange('taluk')}
                placeholder='Taluk' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            District<br/>
            <Input focus value={this.state.district}
                onChange={this.onChange('district')}
                placeholder='District' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Phone<br/>
            <Input focus value={this.state.phone}
                onChange={this.onChange('phone')}
                placeholder='Phone' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            State<br/>
            <Input focus value={this.state.state}
                onChange={this.onChange('state')}
                placeholder='State' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
          Pincode<br/>
          <Input fluid focus value={this.state.pincode}
            onChange={this.onChange('pincode')}
            placeholder='Pincode' />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
          GSTIN<br/>
          <Input fluid focus
            onChange={this.onChange('gstin')}
            placeholder='gstin' value={this.state.gstin} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.cancel.bind(this)}>Cancel</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.update.bind(this)}>Save</Button>
          </Grid.Column>
        </Grid>
        <Loading load={load} message={message} />
      </div>
    );
  }
}

export default Edit;
